class ProductOptionsComponent extends HTMLElement {
  constructor() {
      super();
      this.collectionHandle = this.getAttribute('data-collection-handle');
      this.cache = {};

      this.collectionHandleFromURL = this.getCollectionHandleFromURL();
  }

  connectedCallback() {
      const menuItems = this.getMenuItems();

      if (this.collectionHandleFromURL && this.isCollectionHandleInMenuItems(this.collectionHandleFromURL, menuItems)) {
        // Only update and fetch if the products aren't already cached or loaded
        if (!this.cache[this.collectionHandleFromURL]) {
            this.updateActiveItemOnLoad(menuItems);
            this.fetchProducts(this.collectionHandleFromURL);
        }
      }
      
      this.setupClickListeners(menuItems); // Set up click listeners regardless of the URL parameter

      this.initializeModalFunctionality();

     // Variables for sticky logic
     const navigationElement = document.querySelector('.product-pack__navigation');
     const itemsElement = document.querySelector('.product-pack__items');
     let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-desktop-sticky-height").replace(/px/gi, ""));
     let navigationOffsetTop;
     let itemsOffsetTop;
     let navigationPlaceholder = null;
     let itemsPlaceholder = null;
 
     // Function to calculate initial positions (runs only once)
     const calculateInitialOffsets = () => {
         headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-desktop-sticky-height").replace(/px/gi, ""));
         const navigationRect = navigationElement.getBoundingClientRect();
         navigationOffsetTop = navigationRect.top + window.scrollY;
 
         const itemsRect = itemsElement.getBoundingClientRect();
         itemsOffsetTop = itemsRect.top + window.scrollY;
 
         // Variables for height logic
         document.documentElement.style.setProperty('--navigation-height', `${navigationElement.offsetHeight}px`);
         document.documentElement.style.setProperty('--items-height', `${itemsElement.offsetHeight}px`);
     };
 
     calculateInitialOffsets(); 
 
     window.addEventListener('resize', calculateInitialOffsets);
 
     window.addEventListener('scroll', () => {
         if (window.innerWidth < 960) {
             const scrollPosition = window.scrollY;
 
             if (scrollPosition >= navigationOffsetTop - headerHeight) {
                 if (!navigationElement.classList.contains('is-sticky')) {
                     navigationElement.classList.add('is-sticky');
 
                     // Placeholder to prevent Layout Shift
                     if (!navigationPlaceholder) {
                         navigationPlaceholder = document.createElement('div');
                         navigationPlaceholder.style.height = `${navigationElement.offsetHeight}px`;
                         navigationElement.parentNode.insertBefore(navigationPlaceholder, navigationElement);
                     }
                 }
             } else {
                 if (navigationElement.classList.contains('is-sticky')) {
                     navigationElement.classList.remove('is-sticky');
 
                     if (navigationPlaceholder) {
                         navigationPlaceholder.parentNode.removeChild(navigationPlaceholder);
                         navigationPlaceholder = null;
                     }
                 }
             }
 
             // Logic for preview pack items
             if (scrollPosition >= itemsOffsetTop - headerHeight) {
                 if (!itemsElement.classList.contains('is-sticky')) {
                     itemsElement.classList.add('is-sticky');
 
                     if (!itemsPlaceholder) {
                         itemsPlaceholder = document.createElement('div');
                         itemsPlaceholder.style.height = `${itemsElement.offsetHeight}px`;
                         itemsElement.parentNode.insertBefore(itemsPlaceholder, itemsElement);
                     }
                 }
             } else {
                 if (itemsElement.classList.contains('is-sticky')) {
                     itemsElement.classList.remove('is-sticky');
 
                     if (itemsPlaceholder) {
                         itemsPlaceholder.parentNode.removeChild(itemsPlaceholder);
                         itemsPlaceholder = null;
                     }
                 }
             }
         } else {
             [navigationElement, itemsElement].forEach((element) => {
                 element.classList.remove('is-sticky');
             });
             [navigationPlaceholder, itemsPlaceholder] = [navigationPlaceholder, itemsPlaceholder].map(placeholder => {
                 if (placeholder) {
                     placeholder.parentNode.removeChild(placeholder);
                     return null;
                 }
                 return placeholder;
             });
         }
     });
  }

  initializeModalFunctionality() {
     // SubCategory modal and scroll functionality
     const modalTriggers = document.querySelectorAll('.subcollections-nav-modal-trigger');
     modalTriggers.forEach((modalTrigger) => {
       const modal = document.getElementById('modal-pack-subcategories');
     
       if (modalTrigger) {
         modalTrigger.addEventListener('click', () => {
           window.emit('modal:open', null, { modalContent: modal });
           const modalContainer = document.querySelector('.modal.active');
 
           const subcategoryButtons = modalContainer.querySelectorAll('.subcategory-button');
           subcategoryButtons.forEach(button => {
             button.addEventListener('click', (event) => {
               const targetId = event.target.getAttribute('data-scroll-target');
               const targetElement = document.getElementById(targetId);
 
               if (targetElement) {
                 targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                 const closeButton = modalContainer.querySelector('[data-modal-close]');
                 closeButton.click();
               }
             });
           });
         });
       }
     });
  }

  updateAllProductOptions(container) {
    const productOptions = container.querySelectorAll('product-pack-option');
    // Update state of all options item card
    productOptions.forEach(option => {
      option.updateButtonState({ detail: { selectedItems: packState.selectedItems } });
    });
  }

  getCollectionHandleFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('collection_handle');
  }

  getMenuItems() {
      return document.querySelectorAll('[data-collection-handle]');
  }

  isCollectionHandleInMenuItems(collectionHandle, menuItems) {
      return Array.from(menuItems).some(item => item.getAttribute('data-collection-handle') === collectionHandle);
  }

  setupClickListeners(menuItems) {
      menuItems.forEach((item) => {
          item.addEventListener('click', (event) => {
              event.preventDefault();
              const newCollectionHandle = item.getAttribute('data-collection-handle');
              this.updateActiveItem(newCollectionHandle, menuItems);
              this.fetchProducts(newCollectionHandle);
          });
      });
  }

  updateActiveItemOnLoad(menuItems) {
      this.updateActiveItem(this.collectionHandleFromURL, menuItems);
  }

  updateActiveItem(collectionHandle, menuItems) {
      menuItems.forEach((item) => {
          const itemCollectionHandle = item.getAttribute('data-collection-handle');
          item.classList.toggle('product-pack__navigation-link--active', itemCollectionHandle === collectionHandle);
      });
  }

  async fetchProducts(collectionHandle) {
    // Select the child element where the dynamic content will go
    const productContainer = this.querySelector('.product-pack-options__wrapper');

    // Check if products are already cached and avoid fetching again
    if (this.cache[collectionHandle]) {
        productContainer.innerHTML = this.cache[collectionHandle];  // Only update the product options section

        this.updateAllProductOptions(productContainer);
        return;
    }

    try {
        productContainer.textContent = 'Loading products...';

        const response = await fetch(`/collections/${collectionHandle}?section_id=variant-options`);

        if (response.ok) {
            const fetchedHTMLContent = await response.text(); 

            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = fetchedHTMLContent.trim();

            const sectionContent = tempContainer.querySelector('.product-pack-options__wrapper') ? tempContainer.querySelector('.product-pack-options__wrapper').innerHTML : fetchedHTMLContent;

            productContainer.innerHTML = sectionContent;

            this.cache[collectionHandle] = sectionContent;

            this.updateAllProductOptions(productContainer);

            this.initializeModalFunctionality();
        } else {
            throw new Error(`Error fetching products for ${collectionHandle}`);
        }
    } catch (error) {
        productContainer.textContent = 'Error loading products.';
        console.error('Error fetching products:', error);
    }
  }



}

customElements.define('product-options-component', ProductOptionsComponent);

class ProductPackOption extends HTMLElement {
    constructor() {
      super();
  
      this.variantId = this.getAttribute('data-variant-id');
      this.variantTitle = this.getAttribute('data-variant-title');
      this.variantPrice = parseFloat(this.getAttribute('data-variant-price').replace('$', ''));
  
      const imgElement = this.querySelector('.product-pack-option__-media img');
  
      if (imgElement) {
        this.variantImageAttrs = {
          src: imgElement.getAttribute('src'),
          alt: imgElement.getAttribute('alt'),
          srcset: imgElement.getAttribute('srcset'),
          sizes: imgElement.getAttribute('sizes'),
          width: imgElement.getAttribute('width'),
          height: imgElement.getAttribute('height')
        };
      } else {
        console.error('Image not found');
        this.variantImageAttrs = null;
      }
  
      this.addButton = this.querySelector('.add-to-pack-button');
      this.increaseButton = this.querySelector('.increase-quantity');
      this.decreaseButton = this.querySelector('.decrease-quantity');
      this.quantityInput = this.querySelector('.product-pack-option__qty-value');
  
      this.quantity = this.quantityInput;
  
      this.initEvents();

      document.addEventListener('packStateChanged', (event) => {
        this.updateButtonState(event);
      });
    
    }
  
    initEvents() {
      this.addButton.addEventListener('click', () => this.addToPack());
  
      this.increaseButton.addEventListener('click', () => this.increaseQuantity());
      this.decreaseButton.addEventListener('click', () => this.decreaseQuantity());

    }
    
  
    addToPack() {
      if (this.variantImageAttrs) {
        const item = {
          id: this.variantId,
          title: this.variantTitle,
          price: this.variantPrice,
          imageAttrs: this.variantImageAttrs,
          quantity: this.quantity++
        };
  
        packState.addItem(item);
  
        this.addButton.disabled = true;
        this.addButton.classList.add('disabled');
        this.setActive(true);
      } 
    }
  
    increaseQuantity() {
      if (packState.isPackFull()) {
        
        // Show full pack modal
        const content = document.querySelector("#modal-pack-full"); 
        window.emit("modal:open", null, {
          modalContent: content
        });
        
        return; 
      }
      this.quantity++;
      this.quantityInput.value = this.quantity;

      // Update global quantity
      const item = {
        id: this.variantId,
        title: this.variantTitle,
        price: this.variantPrice,
        imageAttrs: this.variantImageAttrs,
        quantity: 1
      };
      packState.addItem(item);
    }
  
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--;
        this.quantityInput.value = this.quantity;
    
        const indexToRemove = packState.getLastIndexOfItem(this.variantId);
        if (indexToRemove !== -1) {
          packState.removeItemByIndex(indexToRemove);
        }
      } else if (this.quantity === 1) {
        const indexToRemove = packState.getLastIndexOfItem(this.variantId);
        if (indexToRemove !== -1) {
          packState.removeItemByIndex(indexToRemove);
          this.quantityInput.value = this.quantity;
    
          this.addButton.disabled = false;
          this.addButton.classList.remove('disabled');
          this.setActive(false);
        }
      }
    }
    
    setActive(isActive) {
      this.classList.toggle('is-active', isActive);
    }

    updateButtonState(event) {
      const isPackFull = packState.isPackFull();
      const isItemInPack = event.detail.selectedItems.some(item => item.id === this.variantId);
      const itemCountInPack = packState.countItemsByVariantId(this.variantId);

      if (isPackFull) {
          this.addButton.disabled = true;
          this.addButton.classList.add('disabled');
          if (isItemInPack) {
            this.setActive(true);
        }
      } 
      else if (!isItemInPack) {
          this.addButton.disabled = false;
          this.addButton.classList.remove('disabled');
          this.setActive(false);
      } else {
        this.addButton.disabled = true;
        this.addButton.classList.add('disabled');
        this.setActive(true);
      }
      
      this.quantity = itemCountInPack;
      this.quantityInput.value = this.quantity;
    }
    
  }
  
  customElements.define('product-pack-option', ProductPackOption);
  
  
  
  class PackPreview extends HTMLElement {
    constructor() {
      super();
      this.maxItems = 3;
      this.currentItems = [];
      this.packItemsList = this.querySelector('#pack-items-list');
      this.fullPackPrice = this.querySelector('#full-pack-price');
      this.discountedPackPrice = this.querySelector('#discounted-pack-price');
      this.submitPack = this.querySelector('#submit-pack');
      this.packInput = this.querySelector('#pack-items');
  
      this.init();
      this.submitPack.addEventListener('click', (event) => this.handleSubmit(event));
    }
  
    init() {
      document.addEventListener('packStateChanged', (event) => {
        this.currentItems = event.detail.selectedItems;
        this.updatePackUI();
      });

      this.packItemsList.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.product-pack__item-remove');
        if (removeButton) {
          const itemIndex = removeButton.getAttribute('data-index');  
          packState.removeItemByIndex(itemIndex); 
        }
      });

      this.updatePackUI();
    }

    handleSubmit(event) {
      event.preventDefault();
    
      if (packState.isPackFull()) {
        const packId = Math.floor(Math.random() * 1000000); // Generate random pack ID
    
        // Count the occurrences of each item.id in this.currentItems
        const itemCountMap = this.currentItems.reduce((acc, item) => {
          if (!acc[item.id]) {
            acc[item.id] = 0;
          }
          acc[item.id] += 1;
          return acc;
        }, {});
    
        const itemsToAdd = Object.keys(itemCountMap).map(itemId => ({
          id: itemId,
          quantity: itemCountMap[itemId], 
          properties: {
            '_pack_id': packId, 
          }
        }));
    
        this.addItemsToCart(itemsToAdd);
      }
    }

    addItemsToCart(items) {
      const requestData = { items };
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestData)
      })
        .then(response => response.json())
        .then(data => {
          window.emit("quick-cart:updated");
          window.emit("quick-cart:open");
          window.emit("cart:updated");
          this.resetPackState();
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
        });
    }

    resetPackState() {
      // Reset the state in PackState
      packState.selectedItems = [];
      
      // Notify that the state has changed
      packState.notifyStateChanged();
    }
    
  
    updatePackUI() {
      this.packItemsList.innerHTML = '';
  
      // Update current items
      this.currentItems.forEach((item, index) => {
        const itemElement = document.createElement('li');
        itemElement.classList.add('product-pack__item', 'is-selected');
    
        const imageWrapper = document.createElement('div');
        imageWrapper.classList.add('product-pack__item-image-wrapper');

        const removeButton = document.createElement('button');
        removeButton.classList.add('product-pack__item-remove');
        removeButton.setAttribute('type', 'button');
        removeButton.setAttribute('data-index', index); 
        removeButton.setAttribute('aria-label', 'Remove from pack');
        removeButton.innerHTML = `
          <svg class="product-pack__item-remove-icon fill-white" width="9" height="9" xmlns="http://www.w3.org/2000/svg">
            <path d="m1 1 7 7m0-7L1 8" stroke="#fff" stroke-width="1.5" fill="none"/>
          </svg>`;

        imageWrapper.appendChild(removeButton);
    
        const imageElement = document.createElement('img');
        imageElement.setAttribute('src', item.imageAttrs.src);
        imageElement.setAttribute('alt', item.imageAttrs.alt);
        imageElement.setAttribute('srcset', item.imageAttrs.srcset);
        imageElement.setAttribute('sizes', item.imageAttrs.sizes);
        imageElement.setAttribute('width', item.imageAttrs.width);
        imageElement.setAttribute('height', item.imageAttrs.height);
    
        imageElement.classList.add('product-pack__item-image'); 

        imageWrapper.appendChild(imageElement);
    
        const titleElement = document.createElement('h6');
        titleElement.classList.add('product-pack__item-title');
        titleElement.textContent = item.title;

    
        itemElement.appendChild(imageWrapper);
        itemElement.appendChild(titleElement);
    
        this.packItemsList.appendChild(itemElement);
      });
  
      for (let i = this.currentItems.length + 1; i <= this.maxItems; i++) {
        const placeholder = document.createElement('li');
        placeholder.classList.add('product-pack__item', 'is-placeholder');
        placeholder.innerHTML = `
          <div class="product-pack__item-image-wrapper">
            <span class="icon icon-plus-small">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.25 1.5V.25h-2.5V1.5h2.5zm-2.5 21v1.25h2.5V22.5h-2.5zM1.5 10.75H.25v2.5H1.5v-2.5zm21 2.5h1.25v-2.5H22.5v2.5zm-21 0H12v-2.5H1.5v2.5zm10.5 0h10.5v-2.5H12v2.5zM10.75 1.5V12h2.5V1.5h-2.5zm0 10.5v10.5h2.5V12h-2.5z" fill="currentColor"></path></svg>
            </span>
          </div>
          <h6 class="product-pack__item-title">Option ${i}</h6>
        `;
        this.packItemsList.appendChild(placeholder);
      }
  
      // Update Pack Price
      this.fullPackPrice.textContent = `$${this.calculateFullPrice()}`;
      this.discountedPackPrice.textContent = `$${this.calculateDiscountedPrice().toFixed(2)}`;
  
      this.updateSubmitButton();
    }

    updateSubmitButton() {
      const itemsLeft = this.maxItems - this.currentItems.length;
  
      if (this.currentItems.length === this.maxItems) {
        this.submitPack.disabled = false;
        this.submitPack.textContent = 'Add to Cart';
        this.packInput.value = JSON.stringify(this.currentItems);
      } else {
        this.submitPack.disabled = true;
        this.submitPack.textContent = `Select ${itemsLeft} more ${itemsLeft === 1 ? 'Option' : 'Options'}`;
      }
    }
  
    calculateFullPrice() {
      return this.currentItems.reduce((total, item) => total + item.price, 0);
    }
  
    calculateDiscountedPrice() {
      return this.calculateFullPrice() * 0.8; 
    }
  }
  
  customElements.define('pack-preview', PackPreview);
  

  class PackState {
    constructor() {
      this.selectedItems = [];
      this.maxItems = 3;
    }
  
    addItem(item) {
      if (this.selectedItems.length < this.maxItems) {
        this.selectedItems.push(item);
        this.notifyStateChanged();
      }
    }

    countItemsByVariantId(variantId) {
      return this.selectedItems.filter(item => item.id === variantId).length;
    }

    getLastIndexOfItem(variantId) {
      for (let i = this.selectedItems.length - 1; i >= 0; i--) {
        if (this.selectedItems[i].id === variantId) {
          return i;
        }
      }
      return -1;  
    }
  
    removeItemByIndex(index) {
      this.selectedItems.splice(index, 1);
      this.notifyStateChanged();
    }
  
    notifyStateChanged() {
      const event = new CustomEvent('packStateChanged', {
        detail: {
          selectedItems: this.selectedItems,
          maxItems: this.maxItems,
        }
      });
      document.dispatchEvent(event);
    }
  
    isPackFull() {
      return this.selectedItems.length >= this.maxItems;
    }
  }
  
  const packState = new PackState();
  
  
